import React from "react";
// import rajeev from '../directorimages/rajeevahuja.png';
import "../styles/Dmssg.css";
import karuna from "../TeamPhotos/Karuna Kanwar.png";
import riteeka from "../TeamPhotos/ritika mahajan.png";
import narinder from "../TeamPhotos/narinder.png";
import mam from "../TeamPhotos/ms_dimple_rana.png";
// import dharam from "../TeamPhotos/Dharamvir.jpeg";
// import megha from "../TeamPhotos/megha.jpg";
// import smita from "../TeamPhotos/smita.jpg";
// import satyam from "../TeamPhotos/Satyam.jpg";
// import img1 from "../global-images/11.png";
import harpreet from "../TeamPhotos/Harpreet.png";
import sunil from "../TeamPhotos/Sunil Kumar.png";
import Baljit from "../TeamPhotos/Baljit Singh.png";
import Simran from "../TeamPhotos/simran.png";
// import Jashanpreet from "../TeamPhotos/Jashanpreet singh.png";
import Aman from "../TeamPhotos/Aman Choudhary.png"
import Priya from "../TeamPhotos/Priya.png"
import Vivak from "../TeamPhotos/Vivek.png"
// import img2 from '../global-images/'
// import temp from '../'
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const advisor = [
  {
    imgSrc: karuna,
    name: "Mrs. Karuna Kanwar",
    designation: "Incubation Manager",
    linkedin:
      "https://www.linkedin.com/in/karuna-kanwar-50293561/?originalSubdomain=in",
  },
  {
    imgSrc: karuna,
    name: "Mrs. Karuna Kanwar",
    designation: "Incubation Manager",
    linkedin:
      "https://www.linkedin.com/in/karuna-kanwar-50293561/?originalSubdomain=in",
  },
];
const teamMembers = [
  // {
  //   imgSrc: satyam,
  //   name: "Satyam Sarma",
  //   designation: "Chief Executive Officer",
  //   linkedin: "https://www.linkedin.com/in/satyam-sarma-b0071a260/",
  // },
  {
    imgSrc: karuna,
    name: "Ms. Karuna Kanwar",
    designation: "Chief Executive Officer",
    linkedin:
      "https://www.linkedin.com/in/karuna-kanwar-50293561/?originalSubdomain=in",
  },
  {
    imgSrc: riteeka,
    name: "Ms. Ritika Mahajan",
    designation: "Manager",
    linkedin: "https://www.linkedin.com/in/ritika-mahajan-8b6996285/",
  },
  {
    imgSrc: harpreet,
    name: "Ms. Harpreet Kaur",
    designation: "Startup Executive",
    linkedin: "https://www.linkedin.com/in/harpreet-k-11691b281/edit/forms/next-action/after-connect-update-profile/",
  },
  {
    imgSrc: narinder,
    name: "Mr. Narinder Kumar",
    designation: "Office Executive",
    linkedin: "https://www.linkedin.com/in/narinder-kumar-0407221a3/",
  },
  
  {
    imgSrc: mam,
    name: "Ms. Dimple Rana",
    designation: "Accounts Executive",
    linkedin: "/",
  },
  {
    imgSrc: sunil,
    name: "Mr. Sunil Kumar",
    designation: "Young professional",
    linkedin: "https://www.linkedin.com/in/sunil-kumar-665314303/",
  },
  {
    imgSrc: Priya,
    name: "Ms. Priya Kumari",
    designation: "Young professional",
    linkedin: "/",
  },
  {
    imgSrc: Baljit,
    name: "Mr. Baljit Singh",
    designation: "Office Attendant",
    linkedin: "/",
  },
  {
    imgSrc: Simran,
    name: "Simran kaur",
    designation: "Intern",
    linkedin: "https://www.linkedin.com/in/simran-kaur4578/",
  },
  {
    imgSrc: Aman,
    name: "Aman Choudhary",
    designation: "Intern",
    linkedin: "/",
  },
  // {
  //   imgSrc: Vivak,
  //   name: "Vivak Kumar",
  //   designation: "Intern",
  //   linkedin: "/",
  // },
];

function Team() {
  return (
    <div className="flex justify-center border-b pt-10 border-gray-500 items-center pb-20 h-auto bg-white">
      <div className="container mx-5 flex-col ">
        {/* <div className=''>
          <h1 className='text-center bg-clip-text text-transparent mb-5 bg-gradient-to-br from-purple-700 to-green-600 text-center mt-5 font-bold text-5xl'>Advisors</h1>
        </div>
        <div className='flex justify-center items-center'>
          <div className="grid xl:grid-cols-2  md:grid-cols-2 gap-3 flex-wrap">
            {advisor.map((member, index) => ( 
              <div key={index} className="outTeam__card hover:scale-90 hover:text-orange-200 transition duration-200 ease-in-out hover:bg-gradient-to-tr from-slate-900 to-green-500">
                <div className='grid grid-cols-1 justify-items-center'>
                  <img src={member.imgSrc} alt={member.name} className="outTeam__cardImg fa-border border-green-400 border-4" />
                  <div className='p-2 font-montserrat font-bold  rounded  text-center'>{member.name}</div>
                  <div className=' font-montserrat rounded  text-center'>{member.designation}</div>
                  <a href={member.linkedin} target="_blank" rel="noopener noreferrer" >
                    <FontAwesomeIcon icon={faLinkedin} className='p-5 ' size="3x" color="#0077B5" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div> */}
        <h1 className="text-center bg-clip-text text-transparent mb-5 bg-gradient-to-tr flex justify-center gap-2 text-black text-center mt-5 font-bold md:text-5xl text-4xl">
          <div className="flex"><div className="text-blue-600">De</div><div>dicated</div></div> Team
        </h1>
        <div className="flex justify-center items-center">
          <div className="grid xl:grid-cols-4 pt-8 md:grid-cols-3 sm:grid-cols-2 gap-10 flex-wrap auto-rows-auto">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className={`text-white lg:w-72 sm:w-60 w-72 rounded-2xl pb-10 pt-4 hover:scale-105 transition duration-100 ease-in-out bg-zinc-900`}
              >
                <div className="grid grid-cols-1 justify-items-center">
                  <img
                    src={member.imgSrc}
                    alt={member.name}
                    className="outTeam__cardImg fa-border border-blue-200 border-2"
                  />
                  <div className="p-2 font-montserrat font-bold  rounded  text-center">
                    {member.name}
                  </div>
                  <div className=" font-montserrat rounded  text-center">
                    {member.designation}
                  </div>
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faLinkedin}
                      className="p-5 "
                      size="3x"
                      color="#0077B5"
                    />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Team;
